/**
 * 返回recaptcha的网路地址
 * @returns {url} string
 */
export const getRecaptchaJsUri = () => {
    let url = '';


    url = 'https://www.recaptcha.net/recaptcha/api.js?render=6LcusCsaAAAAAI2bbBt7Zif88KWZSeFqqSPQAEw1';

    return url;
};

let isLoaded = false;
export const setRecaptchaJsLoaded = (loaded: boolean) => {
    isLoaded = loaded;
};

export const getRecaptchaJsLoaded = () => {
    return isLoaded;
};
